var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"fill-height":""}},[_c('Snackbar'),_c('Loader'),_c('NavBar'),_c('v-main',[_c('v-scroll-y-transition',{attrs:{"hideOnLeave":true}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('Dialog',{ref:"confirm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }